import { NgFor } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-course',
  standalone: true,
  imports: [NgFor],
  templateUrl: './course.component.html',
  styleUrl: './course.component.scss'
})
export class CourseComponent {
  kurse = [
    {
      name: 'Ferienkurs Weihnachten',
      datum: '05.01. – 12.01.2024',
      uhrzeit: '10:00 – 13:00 Uhr',
      ort: 'Bahnhofstraße 95, 35390 Gießen'
    },
    {
      name: 'Theorie Intensivkurs',
      datum: 'Jeden Monat',
      uhrzeit: 'Innerhalb von 7 Tagen',
      ort: 'Fahrschule Tommys, Gießen'
    },
    {
      name: 'Anmeldung jederzeit möglich',
      datum: 'Laufend',
      uhrzeit: 'Individuell planbar',
      ort: 'Bahnhofstraße 95'
    }
  ];
}
